import { useContext, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { ContextApp } from '../../context';
import FilterContentContainer from '../filter-content';
import { FilterMoviesListContainer } from '../containers';
import Spinner from '../spinner';
import ErrorIndicator from '../error-indicator';

const PremieresPage = () => {
    return (
        <section className='filmik'>
            <aside className='filmik__aside'>
                <FilterContentContainer />
            </aside>

            <div className='filmik__content'>
                <FilterMoviesListContainer />
            </div>
        </section>
    );
};

const PremieresPageContainer = () => {
    const { state: { loading, lastType, error }, actions: { moviesRequested, moviesLoaded, prepareQueryString, clearSearchFilter, moviesError }, moviestoreService } = useContext(ContextApp);
    const location = useLocation();
    const query = queryString.parse(location.search,{arrayFormat: 'comma'});

    useLayoutEffect(() => {
        if (lastType !== 'premieres') {
            moviesRequested();
            moviestoreService.getPremieres()
                .then((data) => {
                    moviesLoaded(data, 'premieres');
                })
                .catch((err) => moviesError(err));
        }
        prepareQueryString(query);

        return () => {
            clearSearchFilter();
        }

        // eslint-disable-next-line
    }, []);

    if (loading) {
        return <Spinner />
    }

    if (error) {
        return <ErrorIndicator error={error} />
    }

    return (
        <PremieresPage />
    );
};

export default PremieresPageContainer;